import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import OnBoardModal from './OnBoardModal';
import Stepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';
import StepperIcon from './Components/StepperIcon';
import SignOutIcon from './Components/SignOutIcon';
import SteppersData from './Components/SteppersData';
import CustomStepIcon from './Components/CustomStepIcon';
import StepperContent from './Components/StepperContent';
import useScreenWidth from '../../../store/useScreenWidth';
import { StorageItems } from '../../../utils/storageItems';
import { useStepperStyles } from './Components/stepperStyles';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { darkModeStepperContent, darkModeStepperNav } from '../../../utils/constants';

const Onboarding = () => {
    const isSmallScreen = useScreenWidth();
    const stylecss = useStepperStyles();
    // const onBoardStep = localStorage.getItem(StorageItems.ONBOARDSTEP);
    const selectedComponents = localStorage.getItem(StorageItems.SELECTEDCOMPONENTS);

    const { darkMode } = useDarkModeStore();
    const [activeStep, setActiveStep] = useState<number>(0);
    const [modal, setModal] = useState<boolean>(false);

    const [selected, setSelected] = useState<string[]>(
        selectedComponents ? selectedComponents.split(",") : []
    );

    const goToPreviousStep = () => {
        setActiveStep((prevActiveStep) => {
            const newStep = prevActiveStep - 1;
            // localStorage.setItem(StorageItems.ONBOARDSTEP, newStep.toString());
            return newStep;
        });
    };
    const goToNextStep = () => {
        setActiveStep((prevActiveStep) => {
            const newStep = prevActiveStep + 1;
            // localStorage.setItem(StorageItems.ONBOARDSTEP, newStep.toString());
            return newStep;
        });
    };
    useEffect(() => {
        if (!selectedComponents) {
            console.log('click!');
            setModal(true);
        }
        else setModal(false);
    }, []);

    const alwaysInclude = ["introduction", "companyDetails", "summary"];
    const filteredSteps = SteppersData.filter((step) => {
        if (selected && selected.length > 0) {
            return alwaysInclude.includes(step.list) || selected.includes(step.list);
        } else {
            return alwaysInclude.includes(step.list);
        }
    });


    return <div className={`d-flex ${isSmallScreen ? 'flex-column' : 'flex-row'}`}>
        <Box
            sx={{
                width: isSmallScreen ? '100vw' : '20vw',
                height: '100vh',
                overflowY: 'auto',
                backgroundColor: darkMode ? darkModeStepperNav : 'white',
            }}>
            <StepperIcon />
            <Stepper
                activeStep={activeStep}
                orientation="vertical"
                sx={stylecss}
            >
                {
                    // SteppersData
                    filteredSteps
                        .map((step) => (
                            <Step key={step.label}>
                                <StepLabel
                                    StepIconComponent={(props) => (
                                        <CustomStepIcon
                                            active={props.active ?? false}
                                            withoutDots={step.child ?? false}
                                            completed={props.completed ?? false}
                                        />
                                    )}
                                >
                                    {step.label}
                                </StepLabel>
                            </Step>
                        ))}
            </Stepper>
            <SignOutIcon />
        </Box>
        <div
            style={{
                width: '80vw',
                height: '100vh',
                overflowY: 'auto',
                background: darkMode ? darkModeStepperContent : 'var(--primary-color-background)',
            }}>
            <StepperContent
                activeStep={activeStep}
                filteredSteps={filteredSteps}
                goToNextStep={goToNextStep}
                goToPreviousStep={goToPreviousStep}
            />
        </div>
        {
            modal &&
            <OnBoardModal
                modal={modal}
                selected={selected}
                setModal={setModal}
                setSelected={setSelected}

            />
        }
    </div>
};

export default Onboarding;